import * as tslib_1 from "tslib";
import { Subscriber } from 'rxjs';
import { schedulerNow } from '../utils/now';
var DebugObserver = (function (_super) {
    tslib_1.__extends(DebugObserver, _super);
    function DebugObserver(identifier, logger, scheduler) {
        if (logger === void 0) { logger = console.debug; }
        var _this = _super.call(this, function (v) { return _this.log('N', v); }, function (e) { return _this.log('E', e); }, function () { return _this.logComplete('C'); }) || this;
        _this.identifier = identifier;
        _this.logger = logger;
        _this.scheduler = scheduler;
        _this.start = schedulerNow(_this.scheduler);
        return _this;
    }
    Object.defineProperty(DebugObserver.prototype, "timeSinceStart", {
        get: function () {
            return schedulerNow(this.scheduler) - this.start;
        },
        enumerable: true,
        configurable: true
    });
    DebugObserver.prototype.messageTag = function (notificationType) {
        return "[" + this.identifier + "]" + notificationType + "@" + padWithZeroes(this.timeSinceStart, 7) + ":";
    };
    DebugObserver.prototype.log = function (notificationType, value) {
        this.logger(this.messageTag(notificationType), value);
    };
    DebugObserver.prototype.logComplete = function (notificationType) {
        this.logger(this.messageTag(notificationType));
    };
    return DebugObserver;
}(Subscriber));
export { DebugObserver };
var padWithZeroes = function (number, length) {
    var myString = number.toString();
    while (myString.length < length) {
        myString = ' ' + myString;
    }
    return myString;
};
//# sourceMappingURL=DebugObserver.js.map